module.exports = __webpack_public_path__ + "img/bust_in_silhouette.05696b64.png";